function huInitReveals() {
  var items = document.querySelectorAll('.hu-reveal');
  if (!items.length) return;
  if (!('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('hu-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('hu-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );
  items.forEach(function (el) { observer.observe(el); });
}

function huInitCountUp() {
  var counters = document.querySelectorAll('.hu-count');
  if (!counters.length || !('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        observer.unobserve(el);
        var target = parseFloat(el.dataset.target || '0');
        var suffix = el.dataset.suffix || '';
        var duration = 1200;
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var value = target * eased;
          el.textContent = (Number.isInteger(target) ? Math.round(value) : value.toFixed(1)) + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    },
    { threshold: 0.4 }
  );
  counters.forEach(function (el) { observer.observe(el); });
}

function huInitProductGallery() {
  var galleries = document.querySelectorAll('[data-hu-gallery]');
  galleries.forEach(function (gallery) {
    var main = gallery.querySelector('[data-hu-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-hu-gallery-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.dataset.fullSrc;
        if (!src) return;
        main.src = src;
        thumbs.forEach(function (t) { t.classList.remove('hu-thumb-active'); });
        thumb.classList.add('hu-thumb-active');
      });
    });
  });
}

function huInitVariantSelector() {
  var forms = document.querySelectorAll('[data-hu-product-form]');
  forms.forEach(function (form) {
    var dataScript = form.querySelector('[data-hu-variants]');
    if (!dataScript) return;
    var variants;
    try {
      variants = JSON.parse(dataScript.textContent);
    } catch (e) {
      return;
    }
    var selects = form.querySelectorAll('[data-hu-option-select]');
    var idInput = form.querySelector('[data-hu-variant-id]');
    var priceEl = form.querySelector('[data-hu-price]');
    var compareEl = form.querySelector('[data-hu-compare-price]');
    var priceUsdEl = form.parentNode ? form.parentNode.querySelector('[data-hu-price-usd]') : null;
    var usdRate = parseFloat(form.dataset.huUsdRate || '0');
    var submitBtn = form.querySelector('[data-hu-submit]');
    var submitLabel = submitBtn ? submitBtn.querySelector('[data-hu-submit-label]') : null;

    function formatMoney(cents) {
      return (cents / 100).toLocaleString(document.documentElement.lang || 'es', {
        style: 'currency',
        currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD'
      });
    }

    function formatUsd(cents) {
      if (!usdRate) return '';
      var usdCents = Math.round(cents / usdRate);
      var steps = Math.ceil((usdCents - 99) / 100);
      if (steps < 0) steps = 0;
      var finalCents = steps * 100 + 99;
      return '≈ USD ' + (finalCents / 100).toLocaleString('es', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function findVariant() {
      var selected = Array.prototype.map.call(selects, function (s) { return s.value; });
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
    }

    function updateUI() {
      var variant = findVariant();
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (priceUsdEl && usdRate) priceUsdEl.textContent = formatUsd(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        if (submitLabel) {
          submitLabel.textContent = variant.available
            ? submitBtn.dataset.availableLabel
            : submitBtn.dataset.soldOutLabel;
        }
      }
    }

    selects.forEach(function (select) {
      select.addEventListener('change', updateUI);
    });
    updateUI();
  });
}

function huUpdatePromoBars(cart, excludeProductId) {
  var bars = document.querySelectorAll('[data-hu-promo-progress]');
  bars.forEach(function (bar) {
    var fill = bar.querySelector('[data-hu-promo-fill]');
    var label = bar.querySelector('[data-hu-promo-label]');
    if (!fill) return;
    var needed = parseInt(bar.dataset.needed || '3', 10);
    var excludeId = bar.dataset.excludeProductId || excludeProductId;
    var count = 0;
    cart.items.forEach(function (item) {
      if (excludeId && String(item.product_id) === String(excludeId)) return;
      count += item.quantity;
    });
    var pct = Math.min(100, Math.round((count / needed) * 100));
    fill.style.width = pct + '%';
    if (label) {
      if (count >= needed) {
        label.textContent = label.dataset.doneText || label.textContent;
      } else {
        var remaining = needed - count;
        var tpl = label.dataset.progressText || '';
        label.textContent = tpl.replace('__N__', remaining);
      }
    }
  });
}

function huRenderCartSections(parsedState) {
  if (!parsedState || !parsedState.sections) return;
  [
    { id: 'cart-drawer', selector: '#CartDrawer' },
    { id: 'cart-icon-bubble' }
  ].forEach(function (section) {
    var html = parsedState.sections[section.id];
    if (!html) return;
    var target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
    if (!target) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = section.selector ? doc.querySelector(section.selector) : doc.getElementById(section.id);
    if (fresh) target.innerHTML = fresh.innerHTML;
  });
}

var HU_GIFT_PREF_KEY = 'hu_gift_variant_choice';

function huGetGiftVariantPreference(defaultId) {
  var stored = parseInt(window.localStorage.getItem(HU_GIFT_PREF_KEY), 10);
  return stored ? stored : defaultId;
}

function huSetGiftVariantPreference(variantId) {
  variantId = parseInt(variantId, 10);
  if (!variantId) return;
  window.localStorage.setItem(HU_GIFT_PREF_KEY, String(variantId));
  if (typeof window.huRequestGiftSync === 'function') window.huRequestGiftSync();
}

function huInitGiftColorSelectors(defaultVariantId) {
  var selects = document.querySelectorAll('[data-hu-gift-color-select]');
  if (!selects.length) return;
  var current = huGetGiftVariantPreference(defaultVariantId);
  selects.forEach(function (select) {
    if (current) select.value = String(current);
    select.addEventListener('change', function () {
      huSetGiftVariantPreference(select.value);
      selects.forEach(function (other) {
        if (other !== select) other.value = select.value;
      });
    });
  });
}

function huInitCartGiftSystem() {
  var config = document.querySelector('[data-hu-gift-config]');
  if (!config) return;
  var defaultVariantId = parseInt(config.dataset.giftVariantId, 10);
  var giftProductId = parseInt(config.dataset.giftProductId, 10);
  var needed = parseInt(config.dataset.giftNeeded || '3', 10);
  if (!defaultVariantId || !giftProductId) return;
  var syncing = false;

  huInitGiftColorSelectors(defaultVariantId);

  function countRealItems(cart) {
    var count = 0;
    cart.items.forEach(function (item) {
      if (item.product_id !== giftProductId) count += item.quantity;
    });
    return count;
  }

  function publishUpdate(response) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hu-gift', cartData: response });
    }
  }

  function addGift(variantId) {
    syncing = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble']
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        huRenderCartSections(response);
        publishUpdate(response);
      })
      .catch(function () {})
      .finally(function () { syncing = false; });
  }

  function removeGift(lineKey, thenAddVariantId) {
    syncing = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: lineKey,
        quantity: 0,
        sections: ['cart-drawer', 'cart-icon-bubble']
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        huRenderCartSections(response);
        publishUpdate(response);
        if (thenAddVariantId) addGift(thenAddVariantId);
      })
      .catch(function () {})
      .finally(function () { syncing = false; });
  }

  function sync(cart) {
    huUpdatePromoBars(cart, giftProductId);
    if (syncing) return;
    var realCount = countRealItems(cart);
    var gift = cart.items.filter(function (item) { return item.product_id === giftProductId; })[0];
    var preferredVariantId = huGetGiftVariantPreference(defaultVariantId);

    if (realCount >= needed && !gift) {
      addGift(preferredVariantId);
    } else if (realCount < needed && gift) {
      removeGift(gift.key);
    } else if (realCount >= needed && gift && gift.variant_id !== preferredVariantId) {
      removeGift(gift.key, preferredVariantId);
    }
  }

  function refreshFromServer() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(sync)
      .catch(function () {});
  }

  window.huRequestGiftSync = refreshFromServer;

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'hu-gift') return;
      if (event && event.cartData && event.cartData.items) {
        sync(event.cartData);
      } else {
        refreshFromServer();
      }
    });
  }

  refreshFromServer();
}

document.addEventListener('DOMContentLoaded', function () {
  huInitReveals();
  huInitCountUp();
  huInitProductGallery();
  huInitVariantSelector();
  huInitCartGiftSystem();
  huInitPromoBar();
});
